import SelectTherapeuticPlan from 'presentation/doctor/pages/AddTherapeuticPlan/SelectTherapeuticPlan'
import React from 'react'

export default function makeDoctorSelectTherapeuticPlan() {
  return <SelectTherapeuticPlan />
}
